import Vue from "vue";

const state = {
  payment_id: null
};

const actions = {
  topup(context, payload) {
    payload.payment_provider_redirect_url =
      window.location.origin + "/topupredirect";
    Vue.prototype.$http.post("/api/topup/v1", payload).then(response => {
      context.commit("payment_id", response.data.payment_id);
      window.location.href = response.data.mollie_url;
    });
  },
  topUpResult(context) {
    return Vue.prototype.$http.get("/api/topup/v1/" + context.state.payment_id);
  }
};

const mutations = {
  payment_id(state, payload) {
    state.payment_id = payload;
  }
};
const getters = {};

export const topup = {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
};
